module.exports = "/img/_/_/_/assets/images/creeper/book/common//40.jpg?c99c4be841dd15123434692d8689ce00";